import { IdMap, RMap } from "../collections";
import { makeImmutable, toPairs } from "../core";
import { Money, ProductType, ProductTypeId, } from "../ordering";
import { VolumeParser } from "./VolumeParser";
import { getDuplicates } from "../utils/utils";
import { Sentry } from "../Sentry";
export class ProductTypeParser {
    constructor(params) {
        this.parametrizationParser = params.parametrizationParser;
        this.modifierSettingsParser = params.modifierSettingsParser;
        this.availabilitySpecParser = params.availabilitySpecParser;
        this.productCategories = params.productCategories;
        this.modifierTypes = params.modifierTypes;
        this.schedules = params.schedules;
        this.productTypeGroups = params.productTypeGroups;
        this.modifiers = params.modifiers;
        makeImmutable(this);
    }
    validateAndDeduplicatedProductModififers(id, productType) {
        const productModifiers = productType.productModifiers;
        const duplicatedProductModifiers = getDuplicates(productModifiers);
        if (duplicatedProductModifiers.length > 0) {
            const msg = `Detected duplicated modifier(s) ${duplicatedProductModifiers.map((id) => {
                var _a, _b;
                return `${id}="${Sentry.localizationProvider.localize((_b = (_a = this.modifiers[id]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "?")}"`;
            })} in product ${id}="${Sentry.localizationProvider.localize(productType.name)}"`;
            Sentry.captureException(new Error(msg));
            return [...new Set(productModifiers)];
        }
        return productModifiers;
    }
    parse(id, productType) {
        var _a, _b;
        if (productType.availability === "Hidden") {
            return null;
        }
        const productVolume = (_a = productType.packagingContainersConfigOverride) === null || _a === void 0 ? void 0 : _a.volume;
        const productModifiers = this.validateAndDeduplicatedProductModififers(id, productType);
        return new ProductType({
            id: new ProductTypeId(id),
            productCategory: this.productCategories.rawGet(productType.category),
            volume: productVolume ? VolumeParser.parse(productVolume) : null,
            pricing: this.parametrizationParser
                .parse(productType.price)
                .map((value) => Money.fromBackend(value)),
            modifierTypes: IdMap.fromIterable(productModifiers.map((modifierTypeId) => this.modifierTypes.rawGet(modifierTypeId))),
            groups: (_b = this.productTypeGroups.rawFind(id)) !== null && _b !== void 0 ? _b : IdMap.empty(),
            schedule: productType.availabilitySchedule === null
                ? null
                : this.schedules.rawGet(productType.availabilitySchedule),
            modifierSettings: this.parseModifierSettings(productType),
            availabilitySpec: this.parseAvailabilitySpec(productType),
        });
    }
    parseModifierSettings(productType) {
        return RMap.fromIterable(toPairs(productType.modifierSettings).mapOptional(([modifierId, settings]) => {
            const modifierType = this.modifierTypes.rawFind(modifierId);
            if (modifierType === null) {
                return null;
            }
            return [
                modifierType.id,
                this.modifierSettingsParser.parse(modifierType.itemTypeIds, settings),
            ];
        }));
    }
    parseAvailabilitySpec(productType) {
        return this.availabilitySpecParser.parse(productType.availability, productType.variants, productType.availabilitySchedule === null
            ? null
            : this.schedules.rawGet(productType.availabilitySchedule));
    }
}
